import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_PAYMENT_SUMMARY_360, GET_PAYMENT_SUMMARY_360_SUCCESS, GET_PAYMENT_SUMMARY_360_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getPaymentSummary360({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId, bookingId } = payload.urlParams;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/booking/${bookingId}/payment-summary`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_PAYMENT_SUMMARY_360_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PAYMENT_SUMMARY_360_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PAYMENT_SUMMARY_360_ERROR, payload: error });
  }
}

export function* watchGetPaymentSummary360() {
  yield takeEvery(GET_PAYMENT_SUMMARY_360, getPaymentSummary360);
}

function* getPaymentSummary360Saga() {
  yield all([fork(watchGetPaymentSummary360)]);
}

export default getPaymentSummary360Saga;
